import { Injector } from '@angular/core';
import { Link } from '@com-delta-idp/mnx-ui-kit';
import * as ANALYTICS from '../../pages/landing-page/models/analytics.constant';
import { DataLayerAnalytics } from '../../pages/landing-page/models/analytics.interface';
import { Current, SCREEN_WIDTH, Section } from './models/menu.interfaces';

export class MenuHelpercomponent {
  height = '';
  sections: Section[] = [];
  current: Current = {} as Current;

  constructor(protected injector: Injector) {}

  updateCurrentValues(url: string, label: string, toggle: boolean): Current {
    return { url, label, toggle };
  }

  isValidRedirect(_allowVaChanges: string, link: Link): boolean {
    return (
      typeof _allowVaChanges !== 'undefined' &&
      _allowVaChanges.trim() !== '' &&
      _allowVaChanges === 'true' &&
      link?.url?.includes('myprofile')
    );
  }

  redirectIfUrlOnPrem(link: Link) {
    const _allowVaChanges = this.injector.get('APP_ALLOW_VA_CHANGES');
    if (this.isValidRedirect(_allowVaChanges, link) === true) {
      window.open(link.url, '_self');
    }
  }

  getMenuEvent(
    link: Link,
    sectionTitle: string,
    loggedIn: boolean
  ): DataLayerAnalytics {
    return {
      event: ANALYTICS.EVENT_TYPE.CLICK,
      event_detail: ANALYTICS.EVENT_DETAIL.NAV_CLICK,
      user: {
        attributes: {
          is_logged_in: loggedIn
            ? ANALYTICS.LOGIN_STATUS.AUTHENTICATED
            : ANALYTICS.LOGIN_STATUS.UNAUTHENTICATED
        }
      },
      click: {
        name: link.label,
        type: ANALYTICS.CLICK_DETAIL.LINK,
        page_section: ANALYTICS.CLICK_DETAIL.LEFT_NAV,
        page_subsection: sectionTitle,
        action: ANALYTICS.CLICK_DETAIL.NAV_CLICK
      }
    };
  }

  screenHeight(width: number, height: number, navBarOffSetHeight: number) {
    const headerOffSetHeight = 47;
    return width <= 1200
      ? height - navBarOffSetHeight - headerOffSetHeight + 'px'
      : '100%';
  }

  onResize() {
    return window.innerWidth >= SCREEN_WIDTH.MOBILE;
  }
}
